module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step3@2x.abb90298.webp";